<template>
  <div class="upload-file-form-container">
    <div class="upload-file-form">

      <VcTextField
        class="file-title"
        :value="fileTitle"
        @input="newValue => changeField('fileTitle', newValue)"
        :label="$t('common.actions.types.document.title')" />

      <VcTextArea
        class="file-description"
        :value="fileDescription"
        @input="newValue => changeField('fileDescription', newValue)"
        :label="$t('common.actions.types.document.description')"
        counter="0" />

    </div>
  </div>
</template>

<script>

export default {
  name: 'UploadFileDetailsForm',
  props:{
    fileTitle: {
      type: String,
      required: false
    },
    fileDescription: {
      type: String,
      required: false
    },
    fileUid: {
      type: String,
      required: true
    },
  },
  methods: {
    changeField(field, newValue) {
      const currentItem = {
        fileTitle: this.fileTitle,
        fileDescription: this.fileDescription,
      };
      this.$emit('edit-item', this.fileUid, Object.assign(currentItem, { [field]: newValue }))
    },
  },
}
</script>

<style lang="scss">
@import "@/assets/scss/abstract/_variables.scss";
@import "@/assets/scss/abstract/_mixins.scss";

.upload-file-form-container {
  background-color: $grey-color-21;
  border-radius: 6px;
}

.upload-file-form {
  padding-top: 20px;
  padding-inline: 16px;

  .v-counter {
    display: none;
  }

  .file-description {
    margin-top: 12px;
  }

  .file-signature {
    text-align: start;
    padding-bottom: 22px;

    &--toggle-disabled {
      cursor: pointer;
    }

    &__icon {
      font-size: 40px;
      margin-inline-end: 10px;

      @include sm-and-down {
        height: 25px;
      }
    }

    &__title {
      font-size: 13px;
      font-weight: 600;
    }

    &__sub-title {
      font-size: 12px;
      font-weight: 400;
      color: $grey-color-23;
    }

    &__switch .v-input--selection-controls__input {
      margin: 0 !important;
    }
  }
}

.switch-wrap {
  .file-signature--toggle-disabled & {
    pointer-events: none;
  }
}



</style>
